// @flow
import React, { PureComponent } from "react";
import { get, noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";

import TrackMasterPickWrapper, {
  EmptyStateContainer,
  LoginMainWrapper
} from "./styled-components";
import MessageBox from "../../_molecule/MessageBox";
import TrackMasterPicksRow, {
  type Props as TrackMasterPick
} from "../../_organism/TrackMasterPicksRow";

type Props = {
  userLogged: boolean,
  trackMasterPicksList: TrackMasterPick[],
  loginCallBack: NullaryFn<void>,
  signupCallBack: NullaryFn<void>,
  trackDataSource: string,
  emptyStateMessage: string,
  needsLoginMessage: string
};

export default class TrackMasterPickTemplate extends PureComponent<Props> {
  static defaultProps = {
    userLogged: false,
    loginCallBack: noop,
    signupCallBack: noop,
    trackMasterPicksList: [],
    trackDataSource: "",
    emptyStateMessage: "",
    needsLoginMessage: ""
  };

  render() {
    let renderReturn = null;

    if (this.props.userLogged) {
      renderReturn = get(this.props, "trackMasterPicksList.length") ? (
        <TrackMasterPickWrapper data-qa-label="trackmasterPicks">
          {this.props.trackMasterPicksList.map((trackMasterPick) => (
            <TrackMasterPicksRow
              data-qa-label="trackmasterLine"
              key={`trackMasterPick_${trackMasterPick.number}`}
              horseName={get(trackMasterPick, "horseName", "")}
              info={get(trackMasterPick, "info", "")}
              number={get(trackMasterPick, "number", 0)}
              raceTypeCode={get(trackMasterPick, "raceTypeCode", "T")}
              runnerId={get(trackMasterPick, "runnerId", "")}
              scratched={get(trackMasterPick, "scratched", false)}
              isMorningLine={get(trackMasterPick, "isMorningLine", false)}
              currentOddsNumerator={get(
                trackMasterPick,
                "currentOddsNumerator",
                ""
              )}
              currentOddsDenominator={get(
                trackMasterPick,
                "currentOddsDenominator",
                ""
              )}
            />
          ))}
        </TrackMasterPickWrapper>
      ) : (
        <EmptyStateContainer>
          <MessageBox
            type="infoNoBackground"
            message={this.props.emptyStateMessage}
            isVertical
            hasIcon
          />
        </EmptyStateContainer>
      );
    } else {
      renderReturn = (
        <LoginMainWrapper>
          <MessageBox
            message={this.props.needsLoginMessage}
            type="infoNoBackground"
            onLoginCallback={this.props.loginCallBack}
            onSignupCallback={this.props.signupCallBack}
          />
        </LoginMainWrapper>
      );
    }

    return renderReturn;
  }
}
